exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".data-limit[data-v-3ba3cb07] {\n  border: 1px solid gray;\n  /*border-radius: 5px;*/\n}\n.break-word[data-v-3ba3cb07] {\n  word-break: break-all;\n}\n", ""]);

// exports
